{
  "es": {
    "partner": {
      "actions": {
        "add": "Añadir",
        "changeProfilePicture": "Cambiar foto de perfil",
        "new": "Colaborador",
        "profilePictureFormat": "Debe medir al menos 300x300px",
        "save": "Guardar",
        "sendinvitation": "Enviar invitación",
        "submit": "Guardar",
        "undoChanges": "Deshacer"
      },
      "attributes": {
        "email_address": "Correo electrónico",
        "email_notifications_interval": {
          "daily": "Una vez al día (alrededor del mediodía)",
          "hourly": "Cada hora",
          "twice_daily": "Dos veces al día (mañana/mediodía)",
          "weekly": "Una vez a la semana (lunes al mediodía)"
        },
        "first_name": "Nombre",
        "internal_note": "Nota interna",
        "language": "Idioma",
        "last_name": "Apellidos",
        "phone_landline": "Número de teléfono fijo",
        "phone_mobile": "Número de móvil",
        "profession": "Cargo",
        "session_ended_at": "Última actividad",
        "status": "Estado",
        "title": "Tratamiento"
      },
      "labels": {
        "addExistingCompany": "Añadir a una empresa existente",
        "contactDetails": "Datos de contacto",
        "createNewCompany": "Crear nueva empresa",
        "information": "Información del perfil",
        "newTeamMember": "Nuevo colaborador",
        "notEditable": "Algunos campos dejan de ser editables una vez que el colaborador está activo",
        "partnerAddedState": "<b>Aún no invitado</b>. Se enviará un correo de invitación en cuanto {partner_name} tenga acceso a una decisión, incidencia o documento publicados.",
        "selectedCompany": "Empresa seleccionada",
        "start_by_selecting_project": "Empieza seleccionando un proyecto a la izquierda"
      },
      "toasts": {
        "create": "Colaborador creado",
        "update": "Colaborador actualizado"
      },
      "validation": {
        "mustBeEmailAddress": "Se requiere un correo válido",
        "needFirstName": "El nombre es obligatorio",
        "needLastName": "Los apellidos son obligatorios",
        "requireEmailAddress": "El correo es obligatorio"
      }
    }
  }
}
